import React from 'react'
import styled from '@emotion/styled'
import { TextButton } from 'Components'

export const ObjectiveButtonList = ({ onDelete, onEdit, onCopy, onFreeze, isActive }) => {
  return (
    <Wrapper>
      {onDelete && <TextButton type="danger" onClick={onDelete}> borrar</TextButton>}
      {onCopy && <TextButton onClick={onCopy}>COPIAR</TextButton>}
      {onFreeze && <TextButton type={isActive ? "danger" : undefined} onClick={onFreeze}>{isActive ? 'CONGELAR' : 'DESCONGELAR'}</TextButton>}
      {onEdit && <TextButton onClick={onEdit}>EDITAR</TextButton>}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  float: right;
  margin-bottom: 17px;
`
